import { render, staticRenderFns } from "./DoublesSubTab.vue?vue&type=template&id=1add4cfc&scoped=true"
import script from "./DoublesSubTab.vue?vue&type=script&lang=js"
export * from "./DoublesSubTab.vue?vue&type=script&lang=js"
import style0 from "./DoublesSubTab.vue?vue&type=style&index=0&id=1add4cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add4cfc",
  null
  
)

export default component.exports